<template>
<div class="Blog">
    <br><br>

    <div class="">blog content.</div>
    <br><br>
    media
    <div class="">media</div>
    <br><br>

    <div class="">chess content</div>
</div>
</template>

<script>
export default {
    name: 'BlogComponent',
}
</script>

<style>
.Blog {
    display: none;
}
</style>
